import './Deck.css';

// Vendors
import React from 'react';
import Anime from 'react-anime';
import {CSSTransition} from 'react-transition-group';
import classnames from 'classnames';

// Components
import Card from '../Card/Card';

import STATUS from '../Game/constants';

/**
 * Deck status
 * GAME_START - Cards slide in to the view
 * RENDER_DECK - Render Deck
 */
export default class Deck extends React.Component {
  // Slide cards on game_start
  slideInCards() {
    return(
      <Anime
        easing='easeInOutExpo'
        duration={1000}
        delay={(el, index) => index * 200}
        translateY={(el, index) => [
          '-30%',
          -(index*1.7) + '%']
        }
        translateX={(el, index) => [
          index % 2 === 0 ? '-80vw' : '80vw', // from value
          '0vw'] // to value
        }
        complete={()=>{
          if (this.props.status === STATUS.INTRO) {
            this.props.introCallback();
          } else {
            this.props.callback();
          }
        }}>
        {this.renderCardsToAnimate()}
      </Anime>
    )
  }

  // Cards on slide in
  renderCardsToAnimate() {
    const divStyle = {
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: 0,
      left: 0
    }

    return this.props.cards.map((card, index) => {
      return (
        // Outer div is for the transform property used in positioning
        <div key={card.value} style={divStyle}>
          <Card
            value={card.value}
            index={index}
            behavior={card.behavior}
            text={card.text}
            flipped={card.flipped}
            classes={card.classes}
            locked={card.locked}
            pinned={card.pinned}
            style={card.style}
            counter={card.counter}
            flipCallback={this.props.flipCallback}
            handlePanEnd={this.props.handlePanEnd}
            handlePanStart={this.props.handlePanStart}
          />
        </div>
      )
    })
  }

  /**
   * Cards for panning
   * should not be wrapped with an extra div
   */
  renderCards() {
    return this.props.cards.map((card, index) => {
      // position the remaining cards on the deck
      const cardStyle = !card.pinned ? {
        transform: `translateY(-${index * 1.7}%)`
      } : {};

      return (
        <Card
          key={card.value}
          value={card.value}
          index={index}
          behavior={card.behavior}
          text={card.text}
          flipped={card.flipped}
          reversed={card.reversed}
          classes={card.classes}
          locked={card.locked}
          pinned={card.pinned}
          deckCardStyle={cardStyle} // style when the cards are on the deck
          style={card.style}
          counter={card.counter}
          flipCallback={this.props.flipCallback}
          handlePanEnd={this.props.handlePanEnd}
          handlePanStart={this.props.handlePanStart}
        />
      )
    })
  }

  /**
   * renderDeck
   * Render cards based on status
   */
  renderDeck() {
    if (this.props.status === STATUS.GAME_START || this.props.status === STATUS.INTRO) {
      // Cards slide in from outside the view
      return this.slideInCards();
    } else if (this.props.status === STATUS.GAME_EXIT) {
      // No need to return cards
      // This is just for spacing
      return;
    } else {
      // Cards for panning
      return this.renderCards();
    }
  }

  render() {
    const showComponent = this.props.status === STATUS.GAME_START ||
                          this.props.status === STATUS.GAME_PLAY ||
                          this.props.status === STATUS.GAME_EXIT ||
                          this.props.status === STATUS.INTRO ||
                          this.props.status === STATUS.INTRO_DEMO;

    const classes = classnames(
      this.props.status,
      'Deck-col',
    );

    return (
      <CSSTransition
        in={showComponent}
        timeout={350}
        classNames="fade"
        exit={false}
        unmountOnExit
        onExited={() => {
          // Pass a callback if it's not an exit from INTRO_DEMO
          // or GAME_EXIT
          if (this.props.status !== STATUS.LOGO && this.props.status !== STATUS.CTA) {
            this.props.callback(true);
          }
        }}
      >
        <div className={classes}>
          <div className="Deck">
            {this.renderDeck()}
          </div>
        </div>
      </CSSTransition>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/rlgl/Deck/Deck.js